<template>
    <Form ref="elFormObj" as="">
        <v-row density="compact">
            <v-col>
                <Field
                    name="birthdate"
                    label="Birthdate"
                    v-slot="{ field, errors }"
                    :model-value="birthdate"
                    :rules="{
                        required,
                        date_is_between: {
                            minDate: min,
                            maxDate: max
                        },
                        ...BirthdateValidationRules
                    }"
                >
                    <v-text-field
                        v-bind="field"
                        :model-value="field.value"
                        @update:model-value="onChange($event)"
                        :error-messages="errors"
                        type="date"
                        name="birthdate"
                        placeholder="yyyy-mm-dd"
                        variant="outlined"
                        :min="min"
                        :max="max"
                        :required="required"
                    ></v-text-field>
                </Field>
            </v-col>
        </v-row>
    </Form>
</template>

<script lang="ts" setup>
    import type { Field, Form } from 'vee-validate';
    import { isString as lo_isString } from 'es-toolkit';
    import { isEmpty as lo_isEmpty } from 'es-toolkit/compat';
    import { initVeeRules, BirthdateValidationRules } from '~/helpers/forms';

    initVeeRules([ 'required', 'date_is_between' ]);

    const props = defineProps({
        modelValue: {
            type: String as PropType<Nullable<string>>,
            required: false,
            default: null
        },
        required: {
            type: Boolean as PropType<boolean>,
            required: false,
            default: false
        },
        min: {
            type: String as PropType<string>,
            required: false,
            default: () => {
                const year = (new Date()).getFullYear() - 110;
                return `${year}-01-01`;
            }
        },
        max: {
            type: String,
            required: false,
            default: () => {
                const year = (new Date()).getFullYear() - 1;
                return `${year}-01-01`;
            }
        }
    });

    const emit = defineEmits([
        'update:modelValue'
    ]);

    const elFormObj = shallowRef<typeof Form>();
    const birthdate = ref();

    const unWatchModel = watch(() => props.modelValue, (val: string | unknown) => {
        birthdate.value = val;
    }, { immediate: true });
    
    async function onChange(val: string) {
        const validateObj = await elFormObj.value?.validate();

        if (lo_isEmpty(val)) {
            emit('update:modelValue', null);
        } else if (validateObj.valid && lo_isString(val)) {
            emit('update:modelValue', val);
        }
    }

    onBeforeUnmount(() => {
        unWatchModel?.();
    });
</script>

<style lang="scss" scoped></style>
